export { default } from './AdsCarousel';